import * as R from 'ramda'

interface ICalculatePercentage {
  value: number
  localValue: number | null
  min: number
  max: number
}

export const getPosition = (e: React.MouseEvent | React.TouchEvent | MouseEvent | TouchEvent) => {
  const { pageX, pageY, clientX, clientY } = 'touches' in e ? e.touches[0] : e
  return { pageX, pageY, clientX, clientY }
}

export const calculatePercentage = ({ value, localValue, min, max }: ICalculatePercentage) => {
  const actual =
    R.isNotNil(localValue) && localValue >= min && localValue <= max ? localValue : value
  return Math.floor(((R.clamp(min, max, actual) - min) / (max - min)) * 100)
}
